<template>
  <span @blur="doSomething">
    <moveable-modus
      v-if="modus === 2"
      :content="value"
      :index="index*10"
      :action="changeModus"      
      :isSelected="isSelected"
      @delete="handleDelete"
      @moveEnd="handleMoveEnd"
      @resize="handleResize"
      @rotate="handleRotate"
    >
      
      <span v-if="value.type === 'Text'" v-html="value.text"></span>
        <div v-if="value.type === 'Image'"   
        
        :style="'background:url(' + value.src + ');width:100%;height:100%;background-repeat:no-repeat;background-position:center center;background-size:'+ ( value.imagePosition ? (value.imagePosition === 'stretch') ? '100% 100%' : value.imagePosition  : 'contain')" 
        
        ></div>
        <!--
          :style="'color: red'+ ( value.imagePosition ? (value.imagePosition === 'stretch') ? '100% 100%' : value.imagePosition  : 'contain')"-->
        <!-- :none="'background:url(' + value.src + ');width:100%;height:100%;background-repeat:no-repeat;background-position:center center;background-size:'+ ( value.imagePosition ? (value.imagePosition === 'stretch') ? '100% 100%' : value.imagePosition  : 'contain')" -->  
        
    </moveable-modus>

    <editor-modus 
        v-if="modus === 1" 
        :index="index*10"
        :isSelected="isSelected"
        :action="changeModus"
        :content="value">        
      <h1>EDIT MODUS</h1>
    </editor-modus>

    <display-modus
      v-if="modus === 3"
      :content="value"
      :index="index*10"
      :action="changeModus"
      :isSelected="isSelected"
    >
      <div v-html="value.text"></div>
    </display-modus>
  </span>
</template>



<script>
import { mapState, mapActions } from "vuex";
import EditorModus from "./editor";
import DisplayModus from "./display";
import MoveableModus from "./moveable";

const MODUS = {
  EDIT: 1,
  MOVE: 2,
  DISPLAY: 3
};

export default {
  components: {
    EditorModus,
    DisplayModus,
    MoveableModus
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      modus: MODUS.MOVE,
      content: "default content"
    };
  },

  computed: {
    isSelected() {
      return this.$store.state.editor.selectedComponent === this.value.uuid;
    },
    objectFillType() {
      //( value.imagePosition ? (value.imagePosition === 'stretch') ? '100% 100%' : value.imagePosition  : 'contain')

      if(this.value.imagePosition) {
        let value = this.value.imagePosition;

        if(value === 'stretch') {
          return 'fill';
        }

        return value;

      }

      return 'cover';
    }
  },
  methods: {
    changeModus(value) {
      this.modus = value;
    },
    handleMoveEnd(data) {
      this.$emit("input", { ...this.value, ...data });
    },
    handleResize(data) {
      this.$emit("input", { ...this.value, ...data });
    },

    handleRotate(data) {
      this.$emit("input", { ...this.value, ...data });
    },

    handleDelete(uid) {
      this.$emit("delete", uid);
    },
    doSomething() {
      alert("do seomthing");
    }

  }
};
</script>

<style lang="scss">
.widgetSelected {
  border: 2px solid pink;
}
</style>